/**
 * 404 Not Found page
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/ui/Button';
import { AlertTriangle } from 'lucide-react';
import { PageLayout, PageContent } from '@/components/PageLayout';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
        <PageContent className="flex flex-col items-center justify-center text-center">
            <AlertTriangle className="w-16 h-16 text-destructive mb-4" />
            <h1 className="text-6xl font-bold">404</h1>
            <p className="text-2xl text-muted-foreground mt-2 mb-6">
                Sorry, the page you visited does not exist.
            </p>
            <Button onClick={() => navigate('/')}>
                Back Home
            </Button>
        </PageContent>
    </PageLayout>
  );
};

export default NotFoundPage;
